import { ErrorResponse, onError } from "@apollo/client/link/error";
import { setBackendError } from "../actions";
import { authManager } from "../global";
import { toBackendErrorCode, TStore } from "../types";

export const createErrorHandlerLink = (store: TStore) => {
    return onError((error: ErrorResponse) => {
        const { graphQLErrors, networkError, operation, forward } = error;

        console.debug("graphql error:", graphQLErrors, ", networkError:", networkError, ", operation:", operation);

        if (graphQLErrors?.length) {
            const err = graphQLErrors[0];
            const code = toBackendErrorCode(err.extensions?.code);

            // an error must never be left unreported, whatever the manager answers
            const handleResult = authManager.handleGraphQLError(code, operation, forward) ?? {};
            if (handleResult.return) return handleResult.return;

            if (!handleResult.handled) {
                store.dispatch(
                    setBackendError({
                        code,
                        details: `Message: ${err.message}` + (err.path ? `\nPath: ${err.path.join(".")}` : ""),
                    }),
                );
            }
        }

        if (networkError && !graphQLErrors) store.dispatch(setBackendError({ code: "unreachable" }));
        return undefined;
    });
};
